import { getCountryData, TCountryCode } from 'countries-list';
import useAppContext from '../../../hooks/useAppContext';

const useArtistPage = () => {
  const { user } = useAppContext();

  const countryData = user?.country
    ? getCountryData(user.country as TCountryCode)
    : undefined;

  return {
    name: user?.name ?? '',
    shortDescription: user?.title ?? '',
    photoUrl: user?.photoUrl ?? '',
    coverUrl: user?.artistProfile?.coverUrl ?? '',
    description: user?.description ?? '',
    countryName: countryData?.name,
    socialMedia: user?.socialMedia ?? [],
  };
};

export default useArtistPage;
